export * from './aside.directive';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/directives/aside/index.ts